"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Variant_1 = require("../constants/Variant");
var ServerSideBehavior = (function () {
    function ServerSideBehavior(serverSideBehaviorId) {
        var _this = this;
        this.evaluateCondition = function (resolverFactory) {
            var serverSideBehaviorResolver = resolverFactory.getLookupResolver(Variant_1.Variant.ServerSideBehavior);
            return (serverSideBehaviorResolver.getBy(_this.serverSideBehaviorId) ===
                _this.serverSideBehaviorId);
        };
        this.getConfiguration = function (_) { return undefined; };
        this.serverSideBehaviorId = serverSideBehaviorId;
    }
    return ServerSideBehavior;
}());
exports.default = ServerSideBehavior;
